import { combineReducers } from 'redux';

import data from './data';
import ui from './ui';

/**
 * @typedef {{
 *   data: import('./data').NotificationDataReducer,
 *   ui: import('./ui').NotificationUIReducer
 * }} NotificationReducer
 */
export default combineReducers({
  data,
  ui,
});
